export default {"src":"/stays/_next/static/media/Partment_logo_from_property_details.12ffa6ec.svg","height":37,"width":112,"blurWidth":0,"blurHeight":0};